import { FinancialSettlementAdvancePayment } from '@dreryk/egabinet-financial-settlement-frontend-api';

import { moneySum } from '@dreryk/react-common';

export const calculateAdvancePaymentsAmount = (advancePayment?: FinancialSettlementAdvancePayment[]): number => {
   if (!Array.isArray(advancePayment)) {
      return 0;
   }

   return advancePayment.reduce<number>(
      (acc, advancePayment) => moneySum(advancePayment.remainingAmount.asNumber(), acc ?? 0),
      0
   );
};
